import type { Breakpoint, ResponsiveLayouts, RGLLayoutItem } from "../../../utils/dashboard.types";
import { BREAKPOINTS, getColsForBreakpoint } from "../../../utils/breakpoints";
import { resolveWidgetDimensions } from "../../../utils/widgetDimensions";
import { findBestPosition } from "../../../utils/layoutPlacement";
import { DEFAULT_ACTIVE_WIDGETS } from "./dashboardConfig";

const RESIZE_HANDLES = ["s", "w", "e", "n", "sw", "nw", "se", "ne"] as const;

export function generateLayout(
    widgetIds: readonly string[],
    breakpoint: Breakpoint,
): RGLLayoutItem[] {
    const cols = getColsForBreakpoint(breakpoint);
    const layout: RGLLayoutItem[] = [];

    for (const id of widgetIds) {
        const { w, h, minW, minH, maxH } = resolveWidgetDimensions(id, cols);
        const { x, y } = findBestPosition(layout, w, h, breakpoint);

        layout.push({
            i: id,
            x,
            y,
            w,
            h,
            minW,
            minH,
            maxH,
            resizeHandles: [...RESIZE_HANDLES],
        });
    }

    return layout;
}

export function generateLayouts(widgetIds: readonly string[]): ResponsiveLayouts {
    return Object.fromEntries(
        BREAKPOINTS.map((breakpoint) => [breakpoint, generateLayout(widgetIds, breakpoint)]),
    ) as ResponsiveLayouts;
}

export const DEFAULT_LAYOUTS: ResponsiveLayouts = generateLayouts(DEFAULT_ACTIVE_WIDGETS);
